export const IMAGE_SIZE_TOLERANCE_MIN = 1024;
export const IMAGE_SIZE_TOLERANCE_RATIO = 0.05;
export const IMAGE_UPLOAD_MAX_ATTEMPTS = 6;

// O backend pode reprocessar/normalizar o arquivo, então o tamanho gravado nem
// sempre bate byte a byte com o original. Aceitamos uma pequena tolerância para
// reconhecer o upload como bem-sucedido em vez de tratá-lo como falha.
export const isSizeWithinTolerance = (actualSize, expectedSize) => {
  if (expectedSize == null) return true;
  const tolerance = Math.max(
    IMAGE_SIZE_TOLERANCE_MIN,
    Math.round(expectedSize * IMAGE_SIZE_TOLERANCE_RATIO)
  );
  return Math.abs(actualSize - expectedSize) <= tolerance;
};

export const isServerImagePresent = (serverBlob, expectedSize = null) => {
  if (!serverBlob || !serverBlob.size) return false;
  return isSizeWithinTolerance(serverBlob.size, expectedSize);
};

export const canResetServerImage = ({
  alreadyUploaded,
  isUploading,
  presentOnServer
}) => !alreadyUploaded && !isUploading && !presentOnServer;

export const SERVER_IMAGE_PRESENT = 'present';
export const SERVER_IMAGE_ABSENT = 'absent';
export const SERVER_IMAGE_UNKNOWN = 'unknown';

// 200 com blob vazio ou fora da tolerância conta como ausência confirmada.
// Sem status, 5xx ou qualquer resposta que não seja 200/404 fica desconhecido:
// nesse caso o reset pode apagar um arquivo que o servidor acabou de gravar.
export const classifyServerImageStatus = ({
  httpStatus,
  blob,
  expectedSize = null
}) => {
  if (typeof httpStatus !== 'number') return SERVER_IMAGE_UNKNOWN;
  if (httpStatus === 404) return SERVER_IMAGE_ABSENT;
  if (httpStatus !== 200) return SERVER_IMAGE_UNKNOWN;

  return isServerImagePresent(blob, expectedSize)
    ? SERVER_IMAGE_PRESENT
    : SERVER_IMAGE_ABSENT;
};

export const canResetServerImageAfterFailedUpload = ({
  alreadyUploaded,
  presentOnServer,
  serverStatusUnknown = false,
  hasInFlightAttempt = false
}) =>
  !alreadyUploaded &&
  !presentOnServer &&
  !serverStatusUnknown &&
  !hasInFlightAttempt;

export const hasUploadHttpStatus = lastUploadError =>
  typeof lastUploadError?.errorStatus === 'number';

export const isItemNotFoundError = (lastUploadError) =>
  Boolean(
    lastUploadError &&
    lastUploadError.errorStatus === 400 &&
    lastUploadError.errorData &&
    lastUploadError.errorData.errormsg === 'Item não encontrado'
  );

export const shouldAttemptResetAfterUploadError = ({
  uploadAttempted,
  isItemNotFound,
  hasHttpStatus
}) => Boolean(uploadAttempted) && !isItemNotFound && Boolean(hasHttpStatus);

// Timeout com órfã não tem arquivo local para reenviar. O pedido não segue.
// Pendência que ainda está na fila (por exemplo limite do servidor) não entra aqui.
export const shouldSubmitOrderAfterUploadWait = ({
  timedOut = false,
  orphanIds = []
} = {}) => !(timedOut && orphanIds.length > 0);

export const shouldLogUploadFailure = (attempts) =>
  attempts === IMAGE_UPLOAD_MAX_ATTEMPTS;
